module.exports = __webpack_public_path__ + "img/messages.50ac258b.svg";